/**
 * Practitioner reviews registry.
 *
 * Add entries by appending to this array. The shape is intentionally simple
 * so non-developers can add reviews by editing this file:
 *   - id            unique slug (kebab-case)
 *   - name          full name with credentials
 *   - title         role + organization
 *   - badge         optional short pill text (e.g., "Beta Founder")
 *   - quote         primary review text
 *   - pull          optional shorter pull quote rendered beneath the primary
 *   - headshot      URL to image. If empty, an initials monogram is rendered.
 *   - initials      override for fallback monogram. Auto-derived from name when omitted.
 */
export const REVIEWS = [
  {
    id: "devon-euring",
    name: "Devon J. Euring, CAPFC",
    title: "Founder and Chief Risk Officer, Asterisk Defense",
    badge: "Beta Founder",
    headshot: "/headshots/devon-euring.jpg",
    initials: "DE",
    rating: 5,
    quote:
      "The output is technically sound, well-sequenced, and immediately actionable for GRC professionals and digital asset counsel. It is not a generic checklist. It earns the trust of subject-matter experts.",
    pull:
      "I built a scenario specifically designed to stress-test the tool across its hardest dimensions. It didn't fold. The output held up under expert scrutiny.",
  },
];
